import { SVG } from 'components/Asset/SVG';
import { LinkButton } from 'components/Buttons/LinkButton';
import { Base } from 'components/Containers/BaseContainer';
import { FlexBox } from 'components/Containers/FlexBox';
import { ToolbarContainer } from 'components/Containers/ToolbarContainer';
import { useState } from 'react';
import { CustomersList } from './components/CustomerList';
import { CreateCustomerModal } from './components/modals/CreateCustomerModal';
import { useAppSelector } from 'store/hook';
import { isDarkTheme } from 'utils/theme';
import { ThemePalette } from 'mui.theme';
import Permission from 'components/Permission/Permission';
import { useTranslation } from 'react-i18next';
import { CLIENT_THEME, clientThemePalette } from 'utils/clientTheme';

export const CustomersView = (): JSX.Element => {
  const { t } = useTranslation();
  const [isCreateCustomerModalOpen, setIsCreateCustomerModalOpen] =
    useState(false);

  const theme = useAppSelector((state) => state.authReducer).customer.theme;
  const enableDarkTheme = isDarkTheme(theme);
  const palette = enableDarkTheme
    ? clientThemePalette[CLIENT_THEME].dark
    : clientThemePalette[CLIENT_THEME].light;

  return (
    <Base enableDarkTheme={enableDarkTheme}>
      <CreateCustomerModal
        key={`${isCreateCustomerModalOpen.toString()}-create-customer-modal`}
        open={isCreateCustomerModalOpen}
        handleAbort={() => {
          setIsCreateCustomerModalOpen(false);
        }}
        title={t('create_a_new_customer_account')}
        enableDarkTheme={enableDarkTheme}
      />
      <ToolbarContainer enableDarkTheme={enableDarkTheme}>
        <FlexBox
          sx={{
            width: '100%',
            justifyContent: 'space-between',
          }}
        >
          <div></div>
          <FlexBox
            sx={{
              display: 'flex',
            }}
          >
            <Permission roles={['director', 'external-director']}>
              <>
                <SVG name="add" style={{ marginRight: '10px' }} />
                <LinkButton
                  onClick={() => {
                    setIsCreateCustomerModalOpen(true);
                  }}
                  color={
                    enableDarkTheme
                      ? ThemePalette.typography.wheat
                      : ThemePalette.typography.primary
                  }
                >
                  {t('add_a_new_customer_account')}
                </LinkButton>
              </>
            </Permission>
          </FlexBox>
        </FlexBox>
      </ToolbarContainer>
      <CustomersList />
    </Base>
  );
};
